// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "neurovox-49ad1.firebaseapp.com",
  "projectId": "neurovox-49ad1",
  "storageBucket": "neurovox-49ad1.appspot.com",
  "messagingSenderId": "486724094026",
  "appId": "1:486724094026:web:1e16635461d2d03bd73eb3",
  "measurementId": "G-SGDDSBWSLS",
  "apiKey": "AIzaSyCXlQ5eoRoUvTlgDV5B3ZMG_xmxLtDLujA"
};
